(() => {
  const initPurchaseModals = (scope = document) => {
    scope.querySelectorAll('.ma-modal[data-purchase-modal]').forEach((modal) => {
      if (modal.dataset.ready === '1') return;
      modal.dataset.ready = '1';

      const form = modal.querySelector('form');
      const dialog = modal.querySelector('.ma-dialog');
      const steps = [...modal.querySelectorAll('.ma-step')];
      const progress = modal.querySelector('.ma-progress i');
      const prev = modal.querySelector('.js-prev');
      const next = modal.querySelector('.js-next');
      const submit = modal.querySelector('.js-submit');
      const errorBox = modal.querySelector('.js-form-error');
      if (!form || !dialog || !steps.length || !prev || !next || !submit) return;

      let currentStep = 1;
      let lastFocus = null;

      const setError = (message = '') => {
        if (!errorBox) return;
        errorBox.textContent = message;
        errorBox.hidden = !message;
      };

      const showStep = (requestedStep) => {
        currentStep = Math.max(1, Math.min(steps.length, requestedStep));
        steps.forEach((step) => {
          step.classList.toggle('active', Number(step.dataset.step) === currentStep);
        });
        if (progress) progress.style.width = `${(currentStep / steps.length) * 100}%`;
        prev.hidden = currentStep === 1;
        next.hidden = currentStep === steps.length;
        submit.hidden = currentStep !== steps.length;
        setError('');
      };

      const validateCurrentStep = () => {
        const activeStep = steps[currentStep - 1];
        const invalidField = [...activeStep.querySelectorAll('[required]')]
          .find((field) => !field.checkValidity());

        if (!invalidField) return true;
        invalidField.reportValidity();
        invalidField.focus();
        return false;
      };

      const openModal = (button) => {
        const variantId = button.dataset.id;
        if (!variantId) return;

        form.reset();
        form.querySelector('.js-id').value = variantId;
        form.querySelector('.js-service').value = button.dataset.title || '';
        modal.querySelector('.js-title').textContent = button.dataset.title || 'Servizio Meta Ads';
        modal.querySelector('.js-price').textContent = button.dataset.price || '';
        showStep(1);

        lastFocus = document.activeElement;
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        requestAnimationFrame(() => dialog.focus());
      };

      const closeModal = () => {
        if (submit.disabled) return;
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        setError('');
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      };

      document.querySelectorAll(`[data-modal-target="${modal.id}"]`).forEach((button) => {
        if (button.dataset.purchaseBound === '1') return;
        button.dataset.purchaseBound = '1';
        button.addEventListener('click', (event) => {
          event.preventDefault();
          openModal(button);
        });
      });

      modal.querySelectorAll('.js-close').forEach((button) => {
        button.addEventListener('click', closeModal);
      });

      next.addEventListener('click', () => {
        if (validateCurrentStep()) showStep(currentStep + 1);
      });

      prev.addEventListener('click', () => showStep(currentStep - 1));

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        setError('');

        if (currentStep < steps.length) {
          if (validateCurrentStep()) showStep(currentStep + 1);
          return;
        }

        if (!form.reportValidity()) return;

        const originalContent = submit.innerHTML;
        submit.disabled = true;
        submit.innerHTML = '<span class="ma-submit-spinner" aria-hidden="true"></span> Apertura pagamento…';

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: new FormData(form),
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
          });

          let payload = {};
          try { payload = await response.json(); } catch (_) {}

          if (!response.ok) {
            throw new Error(payload.description || payload.message || 'Non è stato possibile aggiungere il servizio al carrello.');
          }

          window.location.assign('/checkout');
        } catch (error) {
          setError(error?.message || 'Si è verificato un errore. Riprova tra pochi secondi.');
          submit.disabled = false;
          submit.innerHTML = originalContent;
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !modal.hidden) closeModal();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initPurchaseModals());
  } else {
    initPurchaseModals();
  }

  document.addEventListener('shopify:section:load', (event) => initPurchaseModals(event.target));
})();